// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__2sbTU","spin":"loader_spin__3WO-j"};